import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ActionClose_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.46967 3.46967C3.76256 3.17678 4.23744 3.17678 4.53033 3.46967L10 8.93934L15.4697 3.46967C15.7626 3.17678 16.2374 3.17678 16.5303 3.46967C16.8232 3.76256 16.8232 4.23744 16.5303 4.53033L11.0607 10L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L10 11.0607L4.53033 16.5303C4.23744 16.8232 3.76256 16.8232 3.46967 16.5303C3.17678 16.2374 3.17678 15.7626 3.46967 15.4697L8.93934 10L3.46967 4.53033C3.17678 4.23744 3.17678 3.76256 3.46967 3.46967Z"
            />
        </SvgStyled>
    );
};

export default ActionClose_sm;
